export default __webpack_public_path__ + "static/icon_defipulse-627af5ae757532d87fc54297ff7642b8.svg";